<div class="sidebar-sticky text-center">
  <ul
    class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
    id="accordionSidebar"
  >
    <a
      class="sidebar-brand d-flex align-items-center justify-content-center"
      [routerLink]="'/'"
    >
      <div *ngIf="institutionImgUrl; else escritha_logo" class="sidebar-brand-icon">
        <img [src]="institutionImgUrl" alt="" />
      </div>
      <ng-template #escritha_logo>
        <div class="sidebar-brand-icon">
          <img src="assets/img/logo_escritha_e.png" alt="" />
        </div>
        <div class="sidebar-brand-text mr-3">scritha</div>
      </ng-template>
    </a>

    <hr class="horizontal">

    <ng-container>
      <li class="nav-item nav-my-projects d-flex justify-content-center active">
        <div class="d-flex flex-column">
          <a class="d-flex align-items-center nav-link" routerLink="/">
            <div class="icon-bg">
              <i class="fa fa-clipboard"></i>
            </div>
            <span>Minhas pastas</span>
          </a>
          <a (click)="back()" *ngIf="showBackButton" class="btn btn-sm btn-light btn-back"><i
              class='bx bx-chevron-left'></i> Voltar</a>
        </div>
      </li>
      
      <div *ngIf="showBackButton && showButton" class="btn-group btn-group-toggle margin-buttons" data-toggle="buttons">
        <label #importStudiesLabels class="btn btn-editor-success btn-sm" (click)="importStudiesLabelsClick($event)">
          <input type="radio" name="optionsImportStudies" value="define" />
          concluído
        </label>
        <label #importStudiesLabels class="btn btn-editor-danger btn-sm" (click)="importStudiesLabelsClick($event)">
          <input type="radio" name="optionsImportStudies" value="review" />
          revisar
        </label>
      </div>

      <!-- <hr class="horizontal"> -->

      <div class="sidebar-heading" [hidden]="hideSidebarHeading">Projeto</div>
    </ng-container>
  
    <li [hidden]="item?.hide" *ngFor="let item of menuItems$ | async; index as i" class="nav-item mb-0"
      aria-selected="true">
      <a class="d-flex align-items-center nav-link collapsed {{ item?.disable ? 'not-active' : '' }}"
      [routerLink]="[item.path]" [routerLinkActive]="['active']" [routerLinkActiveOptions]="item.routerLinkActiveOptions">
        <div class="icon-bg">
          <i class="fas fa-fw {{ item.icon }}"></i>
        </div>
        <span>
          {{ item.title }}
          <span *ngIf="item?.totalProjects > -1">({{ item?.totalProjects }})</span>
          <span class="new" *ngIf="item?.newMenu">new</span>
          <span *ngIf="item?.totalOriented > -1">({{ item?.totalOriented }})</span>
        </span>
        <span class="badge badge-pill badge-sidebar badge-light pos" #badgesMenu *ngIf="checkContext(item.title)">
          Ciclo {{ i + 1 }}
        </span>
      </a>
    </li>

    <!-- <hr class="horizontal" style="margin-bottom: 0"> -->

    <ng-container *ngIf="preTextualsMenuItems.length">
      <li class="nav-item mb-0" *ngFor="let item of preTextualsMenuItems" (click)="toggleAndFetch(item)">
         <a [ngClass]="{'destacado': item.selected}" class="nav-link collapsed nav-editor hover" role="button">
           {{ item.description }}
         </a>
      </li>
     </ng-container>

    <ng-container *ngIf="textualsMenuItems.length">
      <ng-container *ngFor="let item of textualsMenuItems">
        <li class="nav-item mb-0" (click)="toggleAndFetch(item)" *ngIf="item.description === 'Seções'">
          <a class="nav-link collapsed nav-editor hover font-weight-bold" role="button">
          {{ item.description }}
          </a>
        </li>

        <li class="nav-item mb-0" (click)="toggleAndFetch(item)" *ngIf="item.description !== 'Seções'">
          <a class="nav-link collapsed nav-editor hover" role="button">
            {{ item.description }}
          </a>
        </li>
      </ng-container>
      <!-- <hr class="sidebar-divider d-none d-md-block"> -->
    </ng-container>

    <div class="chapters-container"></div>

    <ng-container *ngIf="posTextualsMenuItems.length">
      <li class="nav-item mb-0" *ngFor="let item of posTextualsMenuItems" (click)="toggleAndFetch(item)">
        <a class="nav-link collapsed nav-editor hover" role="button">
          {{ item.description }}
        </a>
      </li>
    </ng-container>

    <div class="chapters-container" id="bases-container">
      <h1 (click)="openViewBibtexModal(base.id, base.name)" *ngFor="let base of bases">{{ base.name }}</h1>
    </div>

    <!-- <hr
      class="sidebar-divider"
      *ngIf="posTextualsMenuItems.length || textualsMenuItems.length"
    /> -->
    <hr class="horizontal" *ngIf="posTextualsMenuItems.length || textualsMenuItems.length" />

    <!-- <div *ngIf="showInstitutionRoute || is_superuser" class="sidebar-heading"></div> -->
    <div *ngIf="is_institution || is_superuser" class="sidebar-heading">
      Administração
    </div>

    <li class="nav-item mb-0" [hidden]="!(isSuperUser$ | async)">
      <div class="mt-4 text-left ml-3">
        <small>Administração</small>
      </div>
      <ng-container *ngFor="let item of adminUrls$ | async; index as i">
        <a class="d-flex align-items-center nav-link collapsed nav-editor hover {{ item?.disable ? 'not-active' : '' }}"
          [routerLink]="[item.path]" [routerLinkActive]="['active']">
          <div class="icon-bg">
            <i class="fas fa-fw {{ item.icon }}"></i>
          </div>
          <span>
            {{ item.title }}
          </span>
        </a>
      </ng-container>
    </li>

    <li class="nav-item mb-0" [hidden]="!(isInstitutionAdmin$ | async)">
      <ng-container *ngFor="let item of institutionUrls$ | async; index as i">
        <a class="d-flex align-items-center nav-link collapsed nav-editor hover {{ item?.disable ? 'not-active' : '' }}"
          [routerLink]="[item.path]" [routerLinkActive]="['active']">
          <div class="icon-bg">
            <i class="fas fa-fw {{ item.icon }}"></i>
          </div>
          <span>
            {{ item.title }}
          </span>
        </a>
      </ng-container>
    </li>
  </ul>
  <!-- <app-whatsapp-icon *ngIf="!isEditor"></app-whatsapp-icon> -->
</div>
